// @generated by protobuf-ts 2.11.1 with parameter server_generic,client_generic,generate_dependencies
// @generated from protobuf file "users/v1/service.proto" (package "users.v1", syntax proto3)
// tslint:disable
import { AuthService } from "./service.js";
import { UserCustomerService } from "./service.js";
import { CustomerService } from "./service.js";
import { UserTenantService } from "./service.js";
import { UserService } from "./service.js";
import { TenantService } from "./service.js";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
// Services
/**
 * TenantService manages tenant organizations and their authorization versioning
 *
 * @generated from protobuf service users.v1.TenantService
 */
export class TenantServiceClient {
    _transport;
    typeName = TenantService.typeName;
    methods = TenantService.methods;
    options = TenantService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListTenants retrieves a paginated list of tenants with optional filtering by status and slug
     *
     * @generated from protobuf rpc: ListTenants
     */
    listTenants(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateTenant creates a new tenant organization with the specified name and slug
     *
     * @generated from protobuf rpc: CreateTenant
     */
    createTenant(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetTenant retrieves a specific tenant by its unique identifier
     *
     * @generated from protobuf rpc: GetTenant
     */
    getTenant(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateTenant modifies an existing tenant's properties
     *
     * @generated from protobuf rpc: UpdateTenant
     */
    updateTenant(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteTenant performs a soft delete of a tenant
     *
     * @generated from protobuf rpc: DeleteTenant
     */
    deleteTenant(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * BumpAuthzVersion increments the authorization version to invalidate cached permissions
     *
     * @generated from protobuf rpc: BumpAuthzVersion
     */
    bumpAuthzVersion(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * UserService manages user accounts and their profiles
 *
 * @generated from protobuf service users.v1.UserService
 */
export class UserServiceClient {
    _transport;
    typeName = UserService.typeName;
    methods = UserService.methods;
    options = UserService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListUsers retrieves a paginated list of users with optional filtering
     *
     * @generated from protobuf rpc: ListUsers
     */
    listUsers(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateUser creates a new user account with the specified email and profile
     *
     * @generated from protobuf rpc: CreateUser
     */
    createUser(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetUser retrieves a specific user by their unique identifier
     *
     * @generated from protobuf rpc: GetUser
     */
    getUser(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetUserByEmail retrieves a specific user by their email address
     *
     * @generated from protobuf rpc: GetUserByEmail
     */
    getUserByEmail(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateUser modifies an existing user's profile information
     *
     * @generated from protobuf rpc: UpdateUser
     */
    updateUser(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteUser deactivates a user: soft-deletes the DB row (sets deleted_at) and
     * disables the Cognito identity. Reversible via ReactivateUser.
     *
     * @generated from protobuf rpc: DeleteUser
     */
    deleteUser(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * ResendUserInvite re-sends the Cognito invitation (a fresh temporary
     * password) to a user who was created but has never signed in.
     *
     * gRPC-web only (no google.api.http annotation): the previous REST path was
     * 415'd by the /v1/* gRPC-JSON transcoder, so we deliberately don't re-expose
     * an HTTP route for it.
     *
     * @generated from protobuf rpc: ResendUserInvite
     */
    resendUserInvite(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * ReactivateUser reverses a DeleteUser: clears deleted_at on the DB row and
     * re-enables the Cognito identity.
     *
     * gRPC-web only (no google.api.http annotation), same rationale as
     * ResendUserInvite.
     *
     * @generated from protobuf rpc: ReactivateUser
     */
    reactivateUser(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * UserTenantService manages user-tenant membership relationships
 *
 * @generated from protobuf service users.v1.UserTenantService
 */
export class UserTenantServiceClient {
    _transport;
    typeName = UserTenantService.typeName;
    methods = UserTenantService.methods;
    options = UserTenantService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListUserTenants retrieves user-tenant memberships with optional filtering
     *
     * @generated from protobuf rpc: ListUserTenants
     */
    listUserTenants(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateUserTenant adds a user to a tenant organization
     *
     * @generated from protobuf rpc: CreateUserTenant
     */
    createUserTenant(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateUserTenant modifies a user-tenant membership status
     *
     * @generated from protobuf rpc: UpdateUserTenant
     */
    updateUserTenant(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteUserTenant removes a user from a tenant organization
     *
     * @generated from protobuf rpc: DeleteUserTenant
     */
    deleteUserTenant(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * CustomerService manages customer organizations
 *
 * @generated from protobuf service users.v1.CustomerService
 */
export class CustomerServiceClient {
    _transport;
    typeName = CustomerService.typeName;
    methods = CustomerService.methods;
    options = CustomerService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListCustomers retrieves a paginated list of customers with optional filtering
     *
     * @generated from protobuf rpc: ListCustomers
     */
    listCustomers(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateCustomer creates a new customer organization
     *
     * @generated from protobuf rpc: CreateCustomer
     */
    createCustomer(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetCustomer retrieves a specific customer by its unique identifier
     *
     * @generated from protobuf rpc: GetCustomer
     */
    getCustomer(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateCustomer modifies an existing customer's properties
     *
     * @generated from protobuf rpc: UpdateCustomer
     */
    updateCustomer(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteCustomer performs a soft delete of a customer
     *
     * @generated from protobuf rpc: DeleteCustomer
     */
    deleteCustomer(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * ActivateCustomer sets the activation date for a customer, recording when credentials were shared
     *
     * @generated from protobuf rpc: ActivateCustomer
     */
    activateCustomer(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * UserCustomerService manages (user, customer, group) memberships.
 * All mutations require either global_admin or customer_admin on the target customer.
 *
 * @generated from protobuf service users.v1.UserCustomerService
 */
export class UserCustomerServiceClient {
    _transport;
    typeName = UserCustomerService.typeName;
    methods = UserCustomerService.methods;
    options = UserCustomerService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListUserCustomers retrieves memberships. Filterable by user_id and/or customer_id;
     * at least one must be provided.
     *
     * @generated from protobuf rpc: ListUserCustomers
     */
    listUserCustomers(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateUserCustomer adds a user as a member of a customer with the given group.
     *
     * @generated from protobuf rpc: CreateUserCustomer
     */
    createUserCustomer(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateUserCustomer changes the group on an existing (user, customer) membership.
     *
     * @generated from protobuf rpc: UpdateUserCustomer
     */
    updateUserCustomer(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteUserCustomer removes a user from a customer.
     *
     * @generated from protobuf rpc: DeleteUserCustomer
     */
    deleteUserCustomer(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * AuthService manages user authentication and sessions
 *
 * @generated from protobuf service users.v1.AuthService
 */
export class AuthServiceClient {
    _transport;
    typeName = AuthService.typeName;
    methods = AuthService.methods;
    options = AuthService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * Login authenticates a user with email and password, returning JWT tokens
     *
     * @generated from protobuf rpc: Login
     */
    login(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Logout invalidates the current user session
     *
     * @generated from protobuf rpc: Logout
     */
    logout(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * RefreshToken obtains a new access token using a refresh token
     *
     * @generated from protobuf rpc: RefreshToken
     */
    refreshToken(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetCurrentUser retrieves the authenticated user's information from JWT context
     *
     * @generated from protobuf rpc: GetCurrentUser
     */
    getCurrentUser(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetAccessibleCustomers retrieves customers the authenticated user can access with their group on each
     *
     * @generated from protobuf rpc: GetAccessibleCustomers
     */
    getAccessibleCustomers(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetUserTenants retrieves the authenticated user's tenant memberships
     *
     * @generated from protobuf rpc: GetUserTenants
     */
    getUserTenants(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
//# sourceMappingURL=service.client.js.map